
import { formatToBRL } from './../../../../../../src/utils/formatter';

let ids_gerados =	[
		{
			"id": 303333,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:39:27",
			"updated_at": "2025-06-20 17:39:27",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303332,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:39:05",
			"updated_at": "2025-06-20 17:39:05",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303330,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:38:40",
			"updated_at": "2025-06-20 17:38:40",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303329,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:38:20",
			"updated_at": "2025-06-20 17:38:20",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303328,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:37:56",
			"updated_at": "2025-06-20 17:37:56",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303327,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:37:31",
			"updated_at": "2025-06-20 17:37:31",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303325,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:37:04",
			"updated_at": "2025-06-20 17:37:04",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303324,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:36:13",
			"updated_at": "2025-06-20 17:36:13",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303318,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:32:45",
			"updated_at": "2025-06-20 17:32:45",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303317,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:32:40",
			"updated_at": "2025-06-20 17:32:40",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303316,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:32:32",
			"updated_at": "2025-06-20 17:32:32",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303315,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:32:23",
			"updated_at": "2025-06-20 17:32:23",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303314,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:32:12",
			"updated_at": "2025-06-20 17:32:12",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303313,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:31:57",
			"updated_at": "2025-06-20 17:31:57",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303312,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:31:44",
			"updated_at": "2025-06-20 17:31:44",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303311,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:31:37",
			"updated_at": "2025-06-20 17:31:37",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303310,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:31:30",
			"updated_at": "2025-06-20 17:31:30",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303309,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:31:23",
			"updated_at": "2025-06-20 17:31:23",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303308,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:31:16",
			"updated_at": "2025-06-20 17:31:16",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303307,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:31:10",
			"updated_at": "2025-06-20 17:31:10",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303306,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:31:01",
			"updated_at": "2025-06-20 17:31:01",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303304,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:30:54",
			"updated_at": "2025-06-20 17:30:54",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303303,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:30:48",
			"updated_at": "2025-06-20 17:30:48",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303302,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:30:42",
			"updated_at": "2025-06-20 17:30:42",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303301,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:30:36",
			"updated_at": "2025-06-20 17:30:36",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303300,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:30:32",
			"updated_at": "2025-06-20 17:30:32",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303299,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:30:25",
			"updated_at": "2025-06-20 17:30:25",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303298,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:30:19",
			"updated_at": "2025-06-20 17:30:19",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303297,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:30:13",
			"updated_at": "2025-06-20 17:30:13",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303296,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:30:07",
			"updated_at": "2025-06-20 17:30:07",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303295,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:30:02",
			"updated_at": "2025-06-20 17:30:02",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303294,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:29:55",
			"updated_at": "2025-06-20 17:29:55",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303293,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:29:47",
			"updated_at": "2025-06-20 17:29:47",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303292,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:29:36",
			"updated_at": "2025-06-20 17:29:36",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303290,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:29:29",
			"updated_at": "2025-06-20 17:29:29",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303289,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:29:22",
			"updated_at": "2025-06-20 17:29:22",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303288,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:29:16",
			"updated_at": "2025-06-20 17:29:16",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303287,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:29:09",
			"updated_at": "2025-06-20 17:29:09",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303286,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:29:04",
			"updated_at": "2025-06-20 17:29:04",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303285,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:58",
			"updated_at": "2025-06-20 17:28:58",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303284,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:53",
			"updated_at": "2025-06-20 17:28:53",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303283,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:47",
			"updated_at": "2025-06-20 17:28:47",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303281,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:41",
			"updated_at": "2025-06-20 17:28:41",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303280,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:35",
			"updated_at": "2025-06-20 17:28:35",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303278,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:30",
			"updated_at": "2025-06-20 17:28:30",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303277,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:24",
			"updated_at": "2025-06-20 17:28:24",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303276,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:19",
			"updated_at": "2025-06-20 17:28:19",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303275,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:15",
			"updated_at": "2025-06-20 17:28:15",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303274,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:10",
			"updated_at": "2025-06-20 17:28:10",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303273,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:28:05",
			"updated_at": "2025-06-20 17:28:05",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303272,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:58",
			"updated_at": "2025-06-20 17:27:58",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303271,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:53",
			"updated_at": "2025-06-20 17:27:53",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303270,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:47",
			"updated_at": "2025-06-20 17:27:47",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303269,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:42",
			"updated_at": "2025-06-20 17:27:42",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303268,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:36",
			"updated_at": "2025-06-20 17:27:36",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303267,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:31",
			"updated_at": "2025-06-20 17:27:31",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303266,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:26",
			"updated_at": "2025-06-20 17:27:26",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303265,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:19",
			"updated_at": "2025-06-20 17:27:19",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303264,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:14",
			"updated_at": "2025-06-20 17:27:14",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303263,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:08",
			"updated_at": "2025-06-20 17:27:08",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303262,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:27:03",
			"updated_at": "2025-06-20 17:27:03",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303261,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:58",
			"updated_at": "2025-06-20 17:26:58",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303260,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:54",
			"updated_at": "2025-06-20 17:26:54",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303259,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:49",
			"updated_at": "2025-06-20 17:26:49",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303258,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:44",
			"updated_at": "2025-06-20 17:26:44",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303257,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:39",
			"updated_at": "2025-06-20 17:26:39",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303256,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:33",
			"updated_at": "2025-06-20 17:26:33",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303253,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:26",
			"updated_at": "2025-06-20 17:26:26",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303252,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:19",
			"updated_at": "2025-06-20 17:26:19",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303251,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:12",
			"updated_at": "2025-06-20 17:26:12",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303250,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:07",
			"updated_at": "2025-06-20 17:26:07",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303249,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:26:01",
			"updated_at": "2025-06-20 17:26:01",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303248,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:55",
			"updated_at": "2025-06-20 17:25:55",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303247,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:50",
			"updated_at": "2025-06-20 17:25:50",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303246,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:45",
			"updated_at": "2025-06-20 17:25:45",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303245,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:40",
			"updated_at": "2025-06-20 17:25:40",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303244,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:35",
			"updated_at": "2025-06-20 17:25:35",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303243,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:30",
			"updated_at": "2025-06-20 17:25:30",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303242,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:23",
			"updated_at": "2025-06-20 17:25:23",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303241,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:19",
			"updated_at": "2025-06-20 17:25:19",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303240,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:14",
			"updated_at": "2025-06-20 17:25:14",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303239,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:08",
			"updated_at": "2025-06-20 17:25:08",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303238,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:25:02",
			"updated_at": "2025-06-20 17:25:02",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303237,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:56",
			"updated_at": "2025-06-20 17:24:56",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303236,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:51",
			"updated_at": "2025-06-20 17:24:51",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303235,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:46",
			"updated_at": "2025-06-20 17:24:46",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303234,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:42",
			"updated_at": "2025-06-20 17:24:42",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303233,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:37",
			"updated_at": "2025-06-20 17:24:37",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303232,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:29",
			"updated_at": "2025-06-20 17:24:29",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303231,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:24",
			"updated_at": "2025-06-20 17:24:24",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303230,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:18",
			"updated_at": "2025-06-20 17:24:18",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303229,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:13",
			"updated_at": "2025-06-20 17:24:13",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303228,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:07",
			"updated_at": "2025-06-20 17:24:07",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303227,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:24:01",
			"updated_at": "2025-06-20 17:24:01",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303226,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:56",
			"updated_at": "2025-06-20 17:23:56",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303225,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:50",
			"updated_at": "2025-06-20 17:23:50",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303224,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:45",
			"updated_at": "2025-06-20 17:23:45",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303223,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:40",
			"updated_at": "2025-06-20 17:23:40",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303222,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:35",
			"updated_at": "2025-06-20 17:23:35",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303221,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:30",
			"updated_at": "2025-06-20 17:23:30",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303220,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:25",
			"updated_at": "2025-06-20 17:23:25",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303219,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:19",
			"updated_at": "2025-06-20 17:23:19",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303218,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:13",
			"updated_at": "2025-06-20 17:23:13",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303217,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:08",
			"updated_at": "2025-06-20 17:23:08",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303216,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:23:02",
			"updated_at": "2025-06-20 17:23:02",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303215,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:57",
			"updated_at": "2025-06-20 17:22:57",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303214,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:51",
			"updated_at": "2025-06-20 17:22:51",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303213,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:45",
			"updated_at": "2025-06-20 17:22:45",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303212,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:39",
			"updated_at": "2025-06-20 17:22:39",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303211,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:34",
			"updated_at": "2025-06-20 17:22:34",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303210,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:29",
			"updated_at": "2025-06-20 17:22:29",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303209,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:25",
			"updated_at": "2025-06-20 17:22:25",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303208,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:20",
			"updated_at": "2025-06-20 17:22:20",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303207,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:14",
			"updated_at": "2025-06-20 17:22:14",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303205,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:09",
			"updated_at": "2025-06-20 17:22:09",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303204,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:22:03",
			"updated_at": "2025-06-20 17:22:03",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303203,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:21:58",
			"updated_at": "2025-06-20 17:21:58",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303202,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:21:53",
			"updated_at": "2025-06-20 17:21:53",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303201,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:21:46",
			"updated_at": "2025-06-20 17:21:46",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303200,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:21:38",
			"updated_at": "2025-06-20 17:21:38",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303199,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:21:32",
			"updated_at": "2025-06-20 17:21:32",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303198,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:21:27",
			"updated_at": "2025-06-20 17:21:27",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303197,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:21:20",
			"updated_at": "2025-06-20 17:21:20",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303196,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:21:15",
			"updated_at": "2025-06-20 17:21:15",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303195,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:21:10",
			"updated_at": "2025-06-20 17:21:10",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303194,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:21:05",
			"updated_at": "2025-06-20 17:21:05",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303191,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:58",
			"updated_at": "2025-06-20 17:20:58",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303190,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:52",
			"updated_at": "2025-06-20 17:20:52",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303189,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:48",
			"updated_at": "2025-06-20 17:20:48",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303188,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:43",
			"updated_at": "2025-06-20 17:20:43",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303187,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:36",
			"updated_at": "2025-06-20 17:20:36",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303185,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:31",
			"updated_at": "2025-06-20 17:20:31",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303184,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:26",
			"updated_at": "2025-06-20 17:20:26",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303183,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:21",
			"updated_at": "2025-06-20 17:20:21",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303182,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:17",
			"updated_at": "2025-06-20 17:20:17",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303181,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:12",
			"updated_at": "2025-06-20 17:20:12",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303180,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:20:06",
			"updated_at": "2025-06-20 17:20:06",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303179,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:58",
			"updated_at": "2025-06-20 17:19:58",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303178,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:48",
			"updated_at": "2025-06-20 17:19:48",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303177,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:43",
			"updated_at": "2025-06-20 17:19:43",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303176,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:37",
			"updated_at": "2025-06-20 17:19:37",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303175,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:31",
			"updated_at": "2025-06-20 17:19:31",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303174,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:27",
			"updated_at": "2025-06-20 17:19:27",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303173,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:21",
			"updated_at": "2025-06-20 17:19:21",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303172,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:16",
			"updated_at": "2025-06-20 17:19:16",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303171,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:11",
			"updated_at": "2025-06-20 17:19:11",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303170,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:06",
			"updated_at": "2025-06-20 17:19:06",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303169,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:19:00",
			"updated_at": "2025-06-20 17:19:00",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303168,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:18:55",
			"updated_at": "2025-06-20 17:18:55",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303167,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:18:50",
			"updated_at": "2025-06-20 17:18:50",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303166,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:18:45",
			"updated_at": "2025-06-20 17:18:45",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303165,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:18:40",
			"updated_at": "2025-06-20 17:18:40",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303164,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:18:33",
			"updated_at": "2025-06-20 17:18:33",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303163,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:18:26",
			"updated_at": "2025-06-20 17:18:26",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303162,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:18:21",
			"updated_at": "2025-06-20 17:18:21",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303161,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:18:15",
			"updated_at": "2025-06-20 17:18:15",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303160,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:18:10",
			"updated_at": "2025-06-20 17:18:10",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303159,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:18:05",
			"updated_at": "2025-06-20 17:18:05",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303158,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:59",
			"updated_at": "2025-06-20 17:17:59",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303157,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:54",
			"updated_at": "2025-06-20 17:17:54",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303156,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:49",
			"updated_at": "2025-06-20 17:17:49",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303155,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:43",
			"updated_at": "2025-06-20 17:17:43",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303153,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:37",
			"updated_at": "2025-06-20 17:17:37",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303152,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:32",
			"updated_at": "2025-06-20 17:17:32",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303151,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:28",
			"updated_at": "2025-06-20 17:17:28",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303150,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:23",
			"updated_at": "2025-06-20 17:17:23",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303149,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:18",
			"updated_at": "2025-06-20 17:17:18",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303148,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:14",
			"updated_at": "2025-06-20 17:17:14",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303147,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:09",
			"updated_at": "2025-06-20 17:17:09",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303146,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:17:03",
			"updated_at": "2025-06-20 17:17:03",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303145,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:16:57",
			"updated_at": "2025-06-20 17:16:57",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303144,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:16:49",
			"updated_at": "2025-06-20 17:16:49",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303142,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:16:43",
			"updated_at": "2025-06-20 17:16:43",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303141,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:16:36",
			"updated_at": "2025-06-20 17:16:36",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303140,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:16:30",
			"updated_at": "2025-06-20 17:16:30",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303139,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:16:24",
			"updated_at": "2025-06-20 17:16:24",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303138,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:16:18",
			"updated_at": "2025-06-20 17:16:18",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303137,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:16:12",
			"updated_at": "2025-06-20 17:16:12",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303136,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:16:05",
			"updated_at": "2025-06-20 17:16:05",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303134,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:15:56",
			"updated_at": "2025-06-20 17:15:56",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303133,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:15:49",
			"updated_at": "2025-06-20 17:15:49",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303132,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:15:43",
			"updated_at": "2025-06-20 17:15:43",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303131,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:15:36",
			"updated_at": "2025-06-20 17:15:36",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303130,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:15:29",
			"updated_at": "2025-06-20 17:15:29",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303129,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:15:24",
			"updated_at": "2025-06-20 17:15:24",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303128,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:15:16",
			"updated_at": "2025-06-20 17:15:16",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303127,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:15:09",
			"updated_at": "2025-06-20 17:15:09",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303126,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:15:03",
			"updated_at": "2025-06-20 17:15:03",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303125,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:14:56",
			"updated_at": "2025-06-20 17:14:56",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303124,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:14:51",
			"updated_at": "2025-06-20 17:14:51",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303123,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:14:44",
			"updated_at": "2025-06-20 17:14:44",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303122,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:14:37",
			"updated_at": "2025-06-20 17:14:37",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303121,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:14:32",
			"updated_at": "2025-06-20 17:14:32",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303120,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:14:25",
			"updated_at": "2025-06-20 17:14:25",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303119,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:14:17",
			"updated_at": "2025-06-20 17:14:17",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303118,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:14:11",
			"updated_at": "2025-06-20 17:14:11",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303117,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:14:05",
			"updated_at": "2025-06-20 17:14:05",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303116,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:13:59",
			"updated_at": "2025-06-20 17:13:59",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303115,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:13:53",
			"updated_at": "2025-06-20 17:13:53",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303114,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:13:45",
			"updated_at": "2025-06-20 17:13:45",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303112,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:13:39",
			"updated_at": "2025-06-20 17:13:39",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303111,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:13:31",
			"updated_at": "2025-06-20 17:13:31",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303110,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:13:23",
			"updated_at": "2025-06-20 17:13:23",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303109,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:13:11",
			"updated_at": "2025-06-20 17:13:11",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303107,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:13:00",
			"updated_at": "2025-06-20 17:13:00",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303106,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:12:53",
			"updated_at": "2025-06-20 17:12:53",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303105,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:12:48",
			"updated_at": "2025-06-20 17:12:48",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303104,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:12:42",
			"updated_at": "2025-06-20 17:12:42",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303103,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:12:36",
			"updated_at": "2025-06-20 17:12:36",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303102,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:12:30",
			"updated_at": "2025-06-20 17:12:30",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303101,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:12:24",
			"updated_at": "2025-06-20 17:12:24",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303100,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:12:17",
			"updated_at": "2025-06-20 17:12:17",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303099,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:12:10",
			"updated_at": "2025-06-20 17:12:10",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303098,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:12:02",
			"updated_at": "2025-06-20 17:12:02",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303096,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:11:53",
			"updated_at": "2025-06-20 17:11:53",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303095,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:11:46",
			"updated_at": "2025-06-20 17:11:46",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303094,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:11:40",
			"updated_at": "2025-06-20 17:11:40",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303093,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:11:33",
			"updated_at": "2025-06-20 17:11:33",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303092,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:11:28",
			"updated_at": "2025-06-20 17:11:28",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303091,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:11:21",
			"updated_at": "2025-06-20 17:11:21",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303090,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:11:15",
			"updated_at": "2025-06-20 17:11:15",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303089,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:11:10",
			"updated_at": "2025-06-20 17:11:10",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303088,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:11:04",
			"updated_at": "2025-06-20 17:11:04",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303087,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:10:58",
			"updated_at": "2025-06-20 17:10:58",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303086,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:10:53",
			"updated_at": "2025-06-20 17:10:53",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303085,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:10:44",
			"updated_at": "2025-06-20 17:10:44",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303083,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:10:37",
			"updated_at": "2025-06-20 17:10:37",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303082,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:10:27",
			"updated_at": "2025-06-20 17:10:27",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303081,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:10:16",
			"updated_at": "2025-06-20 17:10:16",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303079,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:10:05",
			"updated_at": "2025-06-20 17:10:05",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303077,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:09:58",
			"updated_at": "2025-06-20 17:09:58",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303076,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:09:52",
			"updated_at": "2025-06-20 17:09:52",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303075,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:09:47",
			"updated_at": "2025-06-20 17:09:47",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303074,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:09:41",
			"updated_at": "2025-06-20 17:09:41",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303073,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:09:34",
			"updated_at": "2025-06-20 17:09:34",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303072,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:09:28",
			"updated_at": "2025-06-20 17:09:28",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303071,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:09:20",
			"updated_at": "2025-06-20 17:09:20",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303070,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:09:11",
			"updated_at": "2025-06-20 17:09:11",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303069,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:09:05",
			"updated_at": "2025-06-20 17:09:05",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303068,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:59",
			"updated_at": "2025-06-20 17:08:59",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303067,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:52",
			"updated_at": "2025-06-20 17:08:52",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303066,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:47",
			"updated_at": "2025-06-20 17:08:47",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303065,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:42",
			"updated_at": "2025-06-20 17:08:42",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303064,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:36",
			"updated_at": "2025-06-20 17:08:36",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303063,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:30",
			"updated_at": "2025-06-20 17:08:30",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303062,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:25",
			"updated_at": "2025-06-20 17:08:25",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303061,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:20",
			"updated_at": "2025-06-20 17:08:20",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303060,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:15",
			"updated_at": "2025-06-20 17:08:15",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303059,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:09",
			"updated_at": "2025-06-20 17:08:09",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303057,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:08:03",
			"updated_at": "2025-06-20 17:08:03",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303056,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:58",
			"updated_at": "2025-06-20 17:07:58",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303055,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:53",
			"updated_at": "2025-06-20 17:07:53",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303054,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:48",
			"updated_at": "2025-06-20 17:07:48",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303053,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:43",
			"updated_at": "2025-06-20 17:07:43",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303052,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:38",
			"updated_at": "2025-06-20 17:07:38",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303051,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:34",
			"updated_at": "2025-06-20 17:07:34",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303050,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:29",
			"updated_at": "2025-06-20 17:07:29",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303049,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:24",
			"updated_at": "2025-06-20 17:07:24",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303048,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:19",
			"updated_at": "2025-06-20 17:07:19",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303047,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:12",
			"updated_at": "2025-06-20 17:07:12",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303046,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:07:05",
			"updated_at": "2025-06-20 17:07:05",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303045,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:56",
			"updated_at": "2025-06-20 17:06:56",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303043,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:49",
			"updated_at": "2025-06-20 17:06:49",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303042,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:44",
			"updated_at": "2025-06-20 17:06:44",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303041,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:39",
			"updated_at": "2025-06-20 17:06:39",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303040,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:33",
			"updated_at": "2025-06-20 17:06:33",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303039,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:28",
			"updated_at": "2025-06-20 17:06:28",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303038,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:24",
			"updated_at": "2025-06-20 17:06:24",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303037,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:19",
			"updated_at": "2025-06-20 17:06:19",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303036,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:14",
			"updated_at": "2025-06-20 17:06:14",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303035,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:10",
			"updated_at": "2025-06-20 17:06:10",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303034,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:06",
			"updated_at": "2025-06-20 17:06:06",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303033,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:06:01",
			"updated_at": "2025-06-20 17:06:01",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303032,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:05:53",
			"updated_at": "2025-06-20 17:05:53",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303031,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:05:47",
			"updated_at": "2025-06-20 17:05:47",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303030,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:05:43",
			"updated_at": "2025-06-20 17:05:43",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303029,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:05:34",
			"updated_at": "2025-06-20 17:05:34",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303027,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:05:27",
			"updated_at": "2025-06-20 17:05:27",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303026,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:05:18",
			"updated_at": "2025-06-20 17:05:18",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303025,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:05:08",
			"updated_at": "2025-06-20 17:05:08",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303024,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:58",
			"updated_at": "2025-06-20 17:04:58",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303023,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:50",
			"updated_at": "2025-06-20 17:04:50",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303022,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:43",
			"updated_at": "2025-06-20 17:04:43",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303021,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:35",
			"updated_at": "2025-06-20 17:04:35",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303020,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:27",
			"updated_at": "2025-06-20 17:04:27",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303019,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:21",
			"updated_at": "2025-06-20 17:04:21",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303018,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:17",
			"updated_at": "2025-06-20 17:04:17",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303017,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:13",
			"updated_at": "2025-06-20 17:04:13",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303016,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:09",
			"updated_at": "2025-06-20 17:04:09",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303015,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:07",
			"updated_at": "2025-06-20 17:04:07",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303014,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:04",
			"updated_at": "2025-06-20 17:04:04",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303013,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:02",
			"updated_at": "2025-06-20 17:04:02",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 303012,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 17:04:01",
			"updated_at": "2025-06-20 17:04:01",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 302989,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 16:36:26",
			"updated_at": "2025-06-20 16:36:26",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 302988,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 16:36:24",
			"updated_at": "2025-06-20 16:36:24",
			"deleted_at": null,
			"notified_at": null
		},
		{
			"id": 302987,
			"id_fc": null,
			"solicitante_id": 525171,
			"cliente_id": 525170,
			"status": "FINALIZADO",
			"carrinho": 1,
			"contador_edicao": 30,
			"created_at": "2025-06-20 16:36:23",
			"updated_at": "2025-06-20 16:36:23",
			"deleted_at": null,
			"notified_at": null
		}
]

const formatTimes = (times) => {
  if (times === undefined || times === null) {
    return 0;
  }
  const timesString = times.toFixed(1);
  return timesString.replace(/\.(?!\.)/g, ",");
}

// 2.85
const residencialRule = (percentage) => {
  return percentage <= 35.08 ? "positivo" : "negativo";
}
// 3.85
const nonResidencialRule = (percentage) => {
  return percentage <= 25.97 ? "positivo" : "negativo";
}

export default (data, tipo_imovel, laudos_sintese, fiadores, applicants, solicitationId) => {
  let e_cliente_teste_excel = false;

	const consultar_faturamento_presumido = applicants && applicants[0] && applicants[0].data.extra.consultar_faturamento_presumido || false;
	const clientId = applicants && applicants[0] && applicants[0].data.extra.client_id ? applicants[0].data.extra.client_id : null;

  ids_gerados.map(solicitacao => {
    if(solicitacao.id == solicitationId) {
      e_cliente_teste_excel = true;
    }
  })

  let origens = '';
  let rendaConjuntaInformada = data.groupedTimesRentalResult
  let rendaConjuntaInformadaIcon = 'neutro'
  let rendaConjuntaPresumida = data.groupedTimesRentalResultPresumida;
  let rendaConjuntaPresumidaIcon = 'neutro'
  let riscoCreditoConjunto = data.parecerMercado;
  let riscoCreditoConjuntoIcon = 'neutro'
  let scoreConjunto = data.score_conjunto;
  let scoreConjuntoIcon = 'neutro'
  let parecerLocacao = data.parecer;
  let parecerLocacaoIcon = 'neutro'
  let temFiadorEstudante = false;
  const isFiadores = fiadores
  const temFcDOC = data.temFcDOC
	const resumo = data.resumo || {}
	const alerta = Array.isArray(data.alertas) && data.alertas.length > 0 ? data.alertas[0] : {};

  laudos_sintese && laudos_sintese.map(sintesePretendente => {
    if(sintesePretendente.tipo_pretendente === 'FIADOR_ESTUDANTE' && isFiadores) {
      temFiadorEstudante = true;
    }
  })

  let temFcScore2 = false;
  applicants.map(applicant => {
    const productFcScore = applicant.data.pretendente.produtos.ativo.filter(product => product.id === 9 && product.status !== 'INCLUIDO')
    const productComplementoReport = applicant.data.pretendente.produtos.ativo.filter(product => product.id === 11 && product.status !== 'INCLUIDO')
    
    if(productFcScore.length && productComplementoReport.length === 0) {
      temFcScore2 = true;
    }
  })

  // const pareceres_keys_elegibles = ['PARECER_NIVEL_1', 'PARECER_NIVEL_2', 'PARECER_NIVEL_3', 'PARECER_NIVEL_4'];

  // if(pareceres_keys_elegibles.includes(data.parecer_key)) {
  //   rendaConjuntaInformadaIcon = 'positivo';
  //   rendaConjuntaPresumidaIcon = 'positivo';
  // } else {
  //   rendaConjuntaInformadaIcon = 'negativo';
  //   rendaConjuntaPresumidaIcon = 'negativo';
  // }

  if (scoreConjunto !== undefined) {
    if (scoreConjunto >= 100) {
      scoreConjuntoIcon = "positivo";
    } else {
      scoreConjuntoIcon = "negativo";
    }
  }

  if(tipo_imovel === 'RESIDENCIAL') {
    if(rendaConjuntaInformada >= 2.85) {
      rendaConjuntaInformadaIcon = 'positivo'
    } else {
      rendaConjuntaInformadaIcon = 'negativo'
    }
    if(rendaConjuntaPresumida >= 2.85) {
      rendaConjuntaPresumidaIcon = 'positivo'
    } else {
      rendaConjuntaPresumidaIcon = 'neutro'
    }
  } else {
    if(rendaConjuntaInformada >= 3.85) {
      rendaConjuntaInformadaIcon = 'positivo'
    } else {
      rendaConjuntaInformadaIcon = 'negativo'
    }
    if(rendaConjuntaPresumida >= 3.85) {
      rendaConjuntaPresumidaIcon = 'positivo'
    } else {
      rendaConjuntaPresumidaIcon = 'neutro'
    }
  }

  if(data.groupedTimesRentalResultPresumidaIcon) {
    rendaConjuntaPresumidaIcon = data.groupedTimesRentalResultPresumidaIcon
  }

  // Só é permitido fiador de estudante em locação RESIDENCIAL
  if(temFiadorEstudante) {
    if(rendaConjuntaInformada >= 3.85) {
      rendaConjuntaInformadaIcon = 'positivo'
    } else {
      rendaConjuntaInformadaIcon = 'negativo'
    }
  }

  if(data.groupedTimesRentalResultIcon) {
    rendaConjuntaInformadaIcon = data.groupedTimesRentalResultIcon
  }

  if(riscoCreditoConjunto === 'RISCO MUITO BAIXO') {
    riscoCreditoConjuntoIcon = 'triangule-green-dark'
  } else if(riscoCreditoConjunto === 'RISCO BAIXO') {
    riscoCreditoConjuntoIcon = 'triangule-green-light'
  } else if(riscoCreditoConjunto === 'RISCO MÉDIO') {
    riscoCreditoConjuntoIcon = 'triangule-yellow'
  } else if(riscoCreditoConjunto === 'RISCO ACIMA DA MÉDIA') {
    riscoCreditoConjuntoIcon = 'triangule-orange'
  } else if(riscoCreditoConjunto === 'RISCO MUITO ALTO') {
    riscoCreditoConjuntoIcon = 'triangule-red'
  }

  if(data.parecer_key === 'PARECER_NIVEL_1') {
    parecerLocacaoIcon = 'triangule-green-dark'
  } else if(data.parecer_key === 'PARECER_NIVEL_2') {
    parecerLocacaoIcon = 'triangule-green-light'
  } else if(data.parecer_key === 'PARECER_NIVEL_3') {
    parecerLocacaoIcon = 'triangule-yellow'
  } else if(data.parecer_key === 'PARECER_NIVEL_4') {
    parecerLocacaoIcon = 'triangule-orange'
  } else if(data.parecer_key === 'PARECER_NIVEL_5') {
    parecerLocacaoIcon = 'triangule-red'
  } else if(data.parecer_key === 'ALERTA_ACAO_CRIMINAL') {
    parecerLocacao = 'ALERTA CRIMINAL - Após análise é possível desconsiderar'
    parecerLocacaoIcon = 'triangule-alert-red'
    // riscoCreditoConjuntoIcon = 'triangule-alert-red'
  } else if(data.parecer_key === 'ALERTA_FRAUDE_CRIMINAL') {
    parecerLocacao = 'ALERTA CRIMINAL - Após análise é possível desconsiderar. Possibilidade de FRAUDE em virtude de excessivas consultas. Recomendamos a análise da documentação e das consultas, o que pode ser solicitado através do FC DOC.'
    parecerLocacaoIcon = 'triangule-alert-red'
    // riscoCreditoConjuntoIcon = 'triangule-alert-red'
  } else if(data.parecer_key === 'ALERTA_FRAUDE') {
    parecerLocacao = 'ALERTA – Possibilidade de FRAUDE em virtude de excessivas consultas. Recomendamos a análise da documentação e das consultas, o que pode ser solicitado através do FC DOC.'
    parecerLocacaoIcon = 'triangule-alert-red'
    // riscoCreditoConjuntoIcon = 'triangule-alert-red'
  } else if(data.parecer_key === 'ALERTA_FCDOC') {
    parecerLocacao = 'ALERTA FC – Ver resultados do FC DOC. Em caso de dúvidas, entre em contato com nosso suporte.'
    parecerLocacaoIcon = 'triangule-alert-red'
    // riscoCreditoConjuntoIcon = 'triangule-alert-red'
  }

  data.origemPerfilFinanceiroConjunto.map(item => {
    origens = origens + item + ', ';
  })

  let origem_perfil_financeiro = {
    icon: 'neutro',
    value: origens.slice(0, -2)
  }

  if(data.origemPerfilFinanceiroConjunto.length) {
		const nao_fornecida = data.origemPerfilFinanceiroConjunto.every(origem => origem === 'Origem Não Informada' || origem === 'Renda Não Informada' || origem === 'Não Possui Renda')
    if(nao_fornecida) {
      origem_perfil_financeiro.icon = 'triangule-alert-red';
      origem_perfil_financeiro.value = 'Não fornecida (importante apurar)';
			if(rendaConjuntaInformada == 0) {
				rendaConjuntaInformadaIcon = 'triangule-alert-red';
      	rendaConjuntaInformada = 'Não fornecida (importante apurar)';
			}
    }
  }

  let acoes_criminais_desconsideradas_pelo = data.acoes_criminais_desconsideradas_pelo ? ` (${data.acoes_criminais_desconsideradas_pelo})` : ''

  let objectReturn = [
    {
      label: temFcDOC ? "RENDAS CONFIRMADAS em conjunto" : "RENDAS INFORMADAS em conjunto",
      status: rendaConjuntaInformadaIcon,
      message: rendaConjuntaInformada == 'Não fornecida (importante apurar)' ? 'Não fornecida (importante apurar)' : formatTimes(rendaConjuntaInformada) + ' vezes a locação'
    },
    {
      label: "ORIGEM Perfil Financeiro ",
      status: origem_perfil_financeiro.icon,
      message: origem_perfil_financeiro.value
    },
    {
      label: "RENDAS PRESUMIDAS em conjunto (Mercado)",
      status: e_cliente_teste_excel ? 'neutro' : rendaConjuntaPresumidaIcon,
      message: e_cliente_teste_excel ? 'Ver em Perfil Financeiro' : formatTimes(rendaConjuntaPresumida) + ' vezes a locação'
    },
    {
      label: "RISCO DE CRÉDITO em conjunto (Mercado)",
      status: riscoCreditoConjuntoIcon,
      message: riscoCreditoConjunto
    },
    {
      label: "RISCO FC em conjunto (nesta locação)",
      status: parecerLocacaoIcon,
      message: parecerLocacao,
			alerta
    },
    {
      label: "SCORE FC em conjunto (nesta locação)",
      status: parecerLocacaoIcon,
      message: scoreConjunto
    },
    {
      label: "NEGATIVAÇÕES DE CRÉDITO*",
      status: (data.temNegativacoes === 'CONSTA')? 'negativo' : "positivo",
      message: (data.temNegativacoes === 'CONSTA')? "ENCONTRADO*" : "NÃO ENCONTRADO*",
			observacao: temFcScore2 && data.temNegativacoes === 'CONSTA' && clientId !== 39931 && clientId !== 228947 ? '(Para detalhamento consulte o Complemento do FC SCORE)': '',
    },
    {
      label: "AÇÕES DE DESPEJO E LOCAÇÃO (Réu)*",
      status: (data.temAcoes === 'CONSTA')? 'negativo' : "positivo",
      message: (data.temAcoes === 'CONSTA')? "ENCONTRADO*" : "NÃO ENCONTRADO*",
			observacao: Object.keys(resumo).length && resumo.restricoes_financeiras.acoes_despejo_locacao.observacao || Object.keys(resumo).length === 0 && '(Para detalhamento consulte o Complemento do FC SCORE)',
      temFcScore: temFcScore2
    },
    {
      label: "AÇÕES CRIMINAIS (Réu)*",
      status: (data.temAcoesCriminais === 'CONSTA')? 'roxo-nulo' : 'neutro',
      message: (data.temAcoesCriminais === 'CONSTA')? `ENCONTRADO*${acoes_criminais_desconsideradas_pelo}` : "NÃO ENCONTRADO*",
			observacao: Object.keys(resumo).length && resumo.restricoes_financeiras.acoes_criminais.observacao || Object.keys(resumo).length === 0 && '(Para detalhamento consulte o Complemento do FC SCORE)',
      temFcScore: temFcScore2
    },
    {
      label: "AÇÕES CÍVEIS (Réu)*",
      status: (data.temAcoesCiveis === 'CONSTA')? 'brown-nulo' : "neutro",
      message: (data.temAcoesCiveis === 'CONSTA')? "ENCONTRADO*" : "NÃO ENCONTRADO*"
    },
    {
      label: "Outras AÇÕES do CNJ (Réu)*",
      status: (data.temAcoesCnjReu === 'CONSTA')? 'black-nulo' : "neutro",
      message: (data.temAcoesCnjReu === 'CONSTA')? "ENCONTRADO*" : "NÃO ENCONTRADO*",
			observacao: Object.keys(resumo).length && resumo.restricoes_financeiras.acoes_outros_cnj_reu.observacao || Object.keys(resumo).length === 0 && '(Para detalhamento consulte o Complemento do FC SCORE)',
      temFcScore: temFcScore2
    },
    {
      label: "Outras AÇÕES do CNJ (Autor) (v. Beta)*",
      status: (data.temAcoesCnjAutor === 'CONSTA')? 'black-nulo' : "neutro",
      message: (data.temAcoesCnjAutor === 'CONSTA')? "ENCONTRADO*" : "NÃO ENCONTRADO*",
			observacao: Object.keys(resumo).length && resumo.restricoes_financeiras.acoes_outros_cnj_autor.observacao || Object.keys(resumo).length === 0 && '(Para detalhamento consulte o Complemento do FC SCORE)',
      temFcScore: temFcScore2
    },
  ]

  if(data.temNegativacoes === undefined) {
    objectReturn = objectReturn.filter(item => item.label != 'NEGATIVAÇÕES DE CRÉDITO*')
  }

  if(data.temAcoes === undefined) {
    objectReturn = objectReturn.filter(item => item.label != 'AÇÕES DE DESPEJO E LOCAÇÃO (Réu)*')
  }

  if(data.temAcoesCriminais === undefined) {
    objectReturn = objectReturn.filter(item => item.label != 'AÇÕES CRIMINAIS (Réu)*')
  }

	if(data.resumo && data.resumo.restricoes_financeiras.acoes_criminais.permission === false) {
    objectReturn = objectReturn.filter(item => item.label != 'AÇÕES CRIMINAIS (Réu)*')
  }

  if(data.temAcoesCiveis === undefined) {
    objectReturn = objectReturn.filter(item => item.label != 'AÇÕES CÍVEIS (Réu)*')
  }

  if(data.temAcoesCnjReu === undefined) {
    objectReturn = objectReturn.filter(item => item.label != 'Outras AÇÕES do CNJ (Réu)*')
  }

  if(data.temAcoesCnjAutor === undefined) {
    objectReturn = objectReturn.filter(item => item.label != 'Outras AÇÕES do CNJ (Autor) (v. Beta)*')
  }

  let temFcScore = false;
  let temFcScoreAcoes = false;
  let temComplementoReport = false;
  let temComplementoReportMais = false;
  applicants.map(applicant => {
    const productFcScore = applicant.data.pretendente.produtos.ativo.filter(product => product.id === 9 && product.status !== 'INCLUIDO')
    const productFcScoreAcoes = applicant.data.pretendente.produtos.ativo.filter(product => product.id === 10 && product.status !== 'INCLUIDO')
    const productComplementoReport = applicant.data.pretendente.produtos.ativo.filter(product => product.id === 11 && product.status !== 'INCLUIDO')
    const productComplementoReportMais = applicant.data.pretendente.produtos.ativo.filter(product => product.id === 12 && product.status !== 'INCLUIDO')
    
    if(productFcScore.length) {
      temFcScore = true;
    }
    if(productFcScoreAcoes.length) {
      temFcScoreAcoes = true;
    }
    if(productComplementoReport.length) {
      temComplementoReport = true;
    }
    if(productComplementoReportMais.length) {
      temComplementoReportMais = true;
    }
  })
  if((temFcScore && temComplementoReport === false && consultar_faturamento_presumido === false) || (temFcScoreAcoes && temComplementoReportMais === false && consultar_faturamento_presumido === false)) {
    objectReturn = objectReturn.filter(item => item.label != 'RENDAS PRESUMIDAS em conjunto (Mercado)')
  }

  return objectReturn
}
